import { Injectable } from '@angular/core';
import { PageTitle } from '../models/general/page-title.model';

@Injectable()
export class Global {
	entityName: string = '';
}
